module.exports = __webpack_public_path__ + "static/img/product_banner_31_zh.90d7b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_31_zh.png
// module id = 3Xb4
// module chunks = 34